import { render, staticRenderFns } from "./employees-settings.vue?vue&type=template&id=04f2609c&"
import script from "./employees-settings.vue?vue&type=script&lang=js&"
export * from "./employees-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports